import { useContext } from 'react';

import CropOrdersContext from './CropOrdersContext';

const useCropOrders = () => useContext(CropOrdersContext);

export default useCropOrders;
